import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../admin/admin.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private adminService: AdminService) { }

  currentLanguage: 'en' | 'es' = 'en';

  electionData: any;

  ngOnInit(): void {

    const savedLanguage = localStorage.getItem('language');

    if (savedLanguage === 'en' || savedLanguage === 'es') {
      this.currentLanguage = savedLanguage;
    }

    this.getActiveElection();

  }

  changeLanguage(lang: 'en' | 'es') {

    this.currentLanguage = lang;

    localStorage.setItem('language', lang);

  }

  getActiveElection() {

    this.adminService.getWithOutToken('get-active-election.json')
      .subscribe(
        (res: any) => {
          this.electionData = res.record;
        },
        err => {
          console.log(err);
        }
      );

  }

  content: any = {

    en: {

      login: 'Login',

      result: 'Results',

      start: 'Start',

      headline:
        'Welcome to the ICA Gender Equality Committee (GEC) 2026 Elections',

      subHeadline:
        'ICA GEC online elections, 21 July 2026.',

      description:
        'Welcome to the online voting system to elect a new Executive Committee, President and Vice-Presidents of the GEC for the 2026–2030 term.',

      instruction:
        'To start the voting process, click the Start button.'

    },

    es: {

      login: 'Iniciar sesión',

      result: 'Resultados',

      start: 'Inicio',

      headline:
        'Bienvenida a las elecciones del Comité de Equidad de Género de la ACI (GEC) 2026',

      subHeadline:
        'Elecciones online del GEC de la ACI, 21 de julio de 2026.',

      description:
        'Bienvenida al sistema de votación electrónico para elegir un nuevo Comité Ejecutivo, Presidencia y Vicepresidencias del GEC para el periodo 2026–2030.',

      instruction:
        'Para comenzar el proceso de votación, pulse el botón Inicio.'

    }

  };

}
